import cls from './Education.module.scss'
import { useTranslation } from "react-i18next";

function Education() {
    const { t } = useTranslation();
    return (
        <section className={cls.education}>
            <h2 className={cls.title}>{t('Education')}</h2>
            <div className={cls.box}>
                <p className={cls.par}>{t('paragraph 5')}</p>
                <p className={cls.par}>{t('paragraph 6')}</p>
                <p className={cls.par}>{t('paragraph 7')}</p>
            </div>
        </section>
    )
}

export default Education;
